/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
import $ from 'jquery';
import globalApps from '@bingads-webui-clientcenter/global-apps';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

/*
$.advertising.pageAlerts provides functions for displaying floating banner through JavaScript.  It contains the
following members:

add(options)
Adds a floating banner.  The options parameter can have the following properties:
    * text -- If the text property is set, it is used for the "plain-text" content of the alert.
    * html -- If the html property is set, it will be used as the HTML content of the alert.
    * cssClass -- Setting cssClass will add a CSS class to the alert; use this to render different styles of alerts.

remove()
Removes the floating banner element from the alerts container.

redirectWithMessage(url, message)
On SPA pages, the redirection happens on client side, so this method just call add and redirect.
*/

$.advertising = $.advertising || {};
$.advertising.pageAlerts = {
  add(alert) {
    const levelMapping = {
      'alert-danger': 'Error',
      'alert-warning': 'Warning',
      'alert-info': 'Info',
      'alert-success': 'Confirmation',
    };
    function alertLevel() {
      for (const key in levelMapping) {
        if (alert.cssClass.indexOf(key) >= 0) {
          return levelMapping[key];
        }
      }

      return 'Info';
    }

    const alertMessage = alert.text || alert.html;

    globalApps.alertCenter.show({
      message: alertMessage,
      level: alertLevel(),
    });
  },
  remove() {
    globalApps.alertCenter.dismiss();
  },
  redirectWithMessage(url, message) {
    if (message) {
      $.advertising.pageAlerts.add(message);
    }
    // Add a refresh query to force the content to refresh
    globalApps.navigate(url, { params: { refresh: generateGuid() } });
  },
  ofClass() {},
};

$.isUndefined = $.isUndefined || function (value) {
  return $.type(value) === 'undefined';
};

$.isString = $.isString || function (value) {
  return $.type(value) === 'string';
};
